export default "__VITE_ASSET__DHCrNfOB__"